import { formatMelbourne } from '../../lib/melbourne-time';
import type { SubscriptionPackage } from '../../queries/subscriptionPackages';

export interface SaleStatus {
  label: string;
  variant: 'outline' | 'warning' | 'primary';
}

/**
 * Where a package stands in its sale window, for the list badge: off sale once
 * the end has passed, not yet on sale before the start, else counting down to
 * a set end. null when it is on sale with no end set.
 */
export function saleStatus(
  pkg: Pick<SubscriptionPackage, 'sale_starts_at' | 'sale_ends_at'>,
  now: Date = new Date(),
): SaleStatus | null {
  const nowMs = now.getTime();
  if (pkg.sale_ends_at && Date.parse(pkg.sale_ends_at) <= nowMs) return { label: 'Off sale', variant: 'outline' };
  if (pkg.sale_starts_at && Date.parse(pkg.sale_starts_at) > nowMs) {
    return { label: `Starts ${formatMelbourne(pkg.sale_starts_at)}`, variant: 'warning' };
  }
  if (pkg.sale_ends_at) return { label: `Sale ends ${formatMelbourne(pkg.sale_ends_at)}`, variant: 'primary' };
  return null;
}
